<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="550"
    [nzVisible]="isVisibleresourceDrawer" [nzTitle]="resourceDrawerTitle" [nzFooter]="footerTpl"
    (nzOnClose)="handleCancel()">
    <form nz-form *nzDrawerContent [formGroup]="_fS.resourceForm">
        
        <div nz-row [nzGutter]="{ xs: 24, sm: 24, md: 24, lg: 24 }">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="nameError">
                        <label class="label-text required">Resource name</label>
                        <input type="text" pattern="^(?!\s+$).+" 
                            class="input-group" nz-input formControlName="resourceName" maxlength="25" minlength="2">
                        <ng-template #nameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter resource name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Resource name must contain at least 2
                                characters</ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter resource name</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        <div nz-col nzSpan="24">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="linkError">
                    <label class="label-text required">Link</label>
                    <input type="text"
                        class="input-group" nz-input formControlName="link" maxlength="256"
                        minlength="2">
                    <ng-template #linkError let-control>
                        <ng-container *ngIf="control.hasError('required')">Please enter link</ng-container>
                        <ng-container *ngIf="control.hasError('pattern')">Please enter valid link
                        </ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
        </div>
    </div>
    </form>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end ">
            <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingOne"
                class="medium-btn small-btn width-100 mr-1">{{selectedResourceData != null ? 'Update' : 'Add'}}</button>
            <button nz-button nzType="default" (click)="handleCancel()"
                class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>